/**
 * @generated SignedSource<<61306c6a82b6234310cda85dd68c53b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateQuoteInput = {
  projectId: string;
  expiryDate?: string | null;
  templateJson?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createQuoteMutation$variables = {
  input: CreateQuoteInput;
};
export type createQuoteMutation$data = {
  readonly createQuote: {
    readonly project: {
      readonly id: string;
      readonly quote: {
        readonly id: string;
        readonly status: string | null;
        readonly revisionNumber: number | null;
        readonly expiryDate: string | null;
        readonly templateJson: string | null;
      } | null;
    } | null;
  } | null;
};
export type createQuoteMutation = {
  variables: createQuoteMutation$variables;
  response: createQuoteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateQuotePayload",
    "kind": "LinkedField",
    "name": "createQuote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Quote",
            "kind": "LinkedField",
            "name": "quote",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "revisionNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateJson",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createQuoteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createQuoteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0256135fc4a6b465c005fbcb4decd80a",
    "id": null,
    "metadata": {},
    "name": "createQuoteMutation",
    "operationKind": "mutation",
    "text": "mutation createQuoteMutation(\n  $input: CreateQuoteInput!\n) {\n  createQuote(input: $input) {\n    project {\n      id\n      quote {\n        id\n        status\n        revisionNumber\n        expiryDate\n        templateJson\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b15cda0dbdfcbb1aa5720498e837871";

export default node;
